import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './style.css';

class PasswordDetail extends React.Component {
  render() {
    const { onClickUpdatePassword } = this.props;
    return (
      <div className={`row ${styles['pt-25']} ${styles['pb-50']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>
            PASSWORD
            <button
              className="btn btn-link pull-right"
              onClick={onClickUpdatePassword}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PasswordDetail.propTypes = {
  data: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    data: {
      moka: state.moka,
    },
  };
}

export default connect(mapStateToProps)(PasswordDetail);
